import type {
  ComplaintCountStatisticsParams,
  ComplaintCountStatisticsResponse,
  IssueStatisticsParams,
  IssueStatisticsResponse,
  ReputationDetailResponse,
  ReputationNewComplaintItem,
  ReputationParams,
  ReputationResponse,
} from './types'
import type { FetchResponseType, PaginationResponse } from '@/server/request/types'
import { useApiFetch } from '@/server/request'

export async function getReputationListApi(params: ReputationParams) {
  return useApiFetch<FetchResponseType<PaginationResponse<ReputationResponse[]>>>('/webportal/base/wom/seriesIssueStatTopPage', {
    method: 'GET',
    params,
    setting: {
      repetition: 'abort',
      splicingParameters: false,
    },
  })
}

export async function getReputationDetailApi(seriesId: string | number) {
  return useApiFetch<FetchResponseType<ReputationDetailResponse>>('/webportal/base/wom/seriesStatDetail', {
    method: 'GET',
    params: { seriesId },
  })
}

export async function getIssueStatisticsApi(params: IssueStatisticsParams, _id?: string) {
  return useApiFetch<FetchResponseType<IssueStatisticsResponse[]>>('/webportal/base/wom/complainIssueStat', {
    method: 'GET',
    params: { id: _id, ...params },
  })
}

export async function getComplaintCountStatisticsApi(params?: ComplaintCountStatisticsParams) {
  return useApiFetch<FetchResponseType<ComplaintCountStatisticsResponse[]>>('/webportal/base/wom/modelYearComplainStat', {
    method: 'GET',
    params,
  })
}

export async function getReputationNewComplaintApi(seriesId: number | string) {
  return useApiFetch<FetchResponseType<ReputationNewComplaintItem[]>>('/webportal/base/wom/modelStatNewComplain', {
    method: 'GET',
    params: { seriesId },
  })
}
